<script lang="js">
import { mapGetters } from "vuex";
import UserBioCard from "@/components/base/UserBioCard.vue";
import MyCoursesCard from "@/components/MyCoursesCard.vue";

export default {
  name: "Academics",
  data() {
    return {
      system_enabled: false,
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    ...mapGetters(["getUser", "getStudent"]),
    user() {
      return this.getUser || {};
    },
    userData() {
      return { ...this.user, ...(this.getStudent || {}) };
    },
  },
  components: { UserBioCard, MyCoursesCard },
};
</script>

<template>
  <div class="p-4 text-start">
    <h4 class="fw-bold">Academics</h4>
    <hr />

    <div class="row g-4 mt-3 mb-5">
      <div class="col-md-6 col-lg-4">
        <h6>Biodata</h6>
        <UserBioCard :userData="userData" />
      </div>

      <div class="col-md-12 col-lg-8" id="timetable">
        <h6>Timetable</h6>
        <div class="card border-0 shadow-sm" style="min-height: 400px">
          <div class="card-body overflow-auto" style="max-height: 400px">
            <div class="row mb-4">
              <h6 class="fw-bold">Today</h6>

              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="n in 3" :key="n">
                  <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                  </p>
                </li>
              </ul>
            </div>

            <div class="row mb-4">
              <h6 class="fw-bold">Tomorrow</h6>

              <ul class="list-group list-group-flush">
                <li class="list-group-item" v-for="n in 2" :key="n">
                  <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div
            v-if="!system_enabled"
            class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3"
            style="z-index: 10; cursor: not-allowed"
          >
            <h5 class="text-white fw-bold">Not activated yet</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 h-100" style="height: 550px !important">
      <div id="courses" class="col-md-6 h-100">
        <h6 class="mt-4">My Courses</h6>
        <MyCoursesCard height="500px" />
      </div>

      <div class="col-md-6 d-flex flex-column h-100">
        <div id="grades">
          <h6 class="mt-4">Grades</h6>
          <div class="card border-0 shadow-sm px-3" style="height: 160px">
            <div class="card-header bg-white border-bottom-0">
              <div class="dropdown">
                <a
                  class="dropdown-toggle text-decoration-none text-dark"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span class="placeholder col-3"></span>
                </a>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">1st Semester</a></li>
                  <li><a class="dropdown-item" href="#">2nd Semester</a></li>
                </ul>
              </div>
              <span class="fw-bold">Grades</span>
            </div>
            <div class="card-body overflow-x-auto">
              <div class="d-flex flex-row">
                <div
                  v-for="n in 10"
                  :key="n"
                  class="d-flex flex-column text-center mx-3"
                >
                  <h6 class="fw-bold text-nowrap">
                    <span class="placeholder col-12"></span>
                  </h6>
                  <span>%%</span>
                </div>
              </div>
            </div>

            <div
              v-if="!system_enabled"
              class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3"
              style="z-index: 10; cursor: not-allowed"
            >
              <h5 class="text-white fw-bold">Not activated yet</h5>
            </div>
          </div>
        </div>

        <!-- Ensure Grade Point Projection takes the remaining height -->
        <div class="d-flex flex-column flex-grow-1 mt-4" id="gpp">
          <h6 class="">Grade Point Projection</h6>
          <div class="card border-0 shadow-sm d-flex flex-grow-1">
            <div
              v-if="!system_enabled"
              class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3"
              style="z-index: 10; cursor: not-allowed"
            >
              <h5 class="text-white fw-bold">Not activated yet</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
